"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeLocaleForMoment = exports.removeMetadata = void 0;
/**
 * Given an object containing the parsed translation bundle, this function creates a new object which contains
 * only key -\> value mapping between translation key and the actual value.
 *
 * @param translationsWithMetadata - parsed translation bundle
 * @internal
 */
function removeMetadata(translationsWithMetadata) {
    var translations = {};
    Object.keys(translationsWithMetadata).forEach(function (key) {
        translations[key] =
            typeof translationsWithMetadata[key] === "object"
                ? translationsWithMetadata[key].value
                : translationsWithMetadata[key];
    });
    return translations;
}
exports.removeMetadata = removeMetadata;
/**
 * Handles difference between GD locale and moment.js locale identifiers
 *
 * @param intlLocale - locale identifier
 * @internal
 */
exports.sanitizeLocaleForMoment = function (intlLocale) {
    if (intlLocale === "zh-Hans") {
        return "zh-CN";
    }
    return intlLocale;
};
//# sourceMappingURL=translationUtils.js.map